export default __webpack_public_path__ + "static/ember2x-ba06e2ce4c47728e75291a67ddedcd24.png";